'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.isstring');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if the value is a String
 *
 * @name isString
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is a String
 */
exports.default = _lodash2.default;
//# sourceMappingURL=isString.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/isString.js
 ** module id = 3
 ** module chunks = 0 1
 **/